export default __webpack_public_path__ + "static/media/close-purple.f3e7b1bc.svg";